export const REQUEST_REPORTS = 'REQUEST_REPORTS';
export const RECEIVE_REPORTS = 'RECEIVE_REPORTS';
export const REQUEST_AUTOMATE_MAILING_REPORTS = 'REQUEST_AUTOMATE_MAILING_REPORTS';
export const RECEIVE_AUTOMATE_MAILING_REPORTS = 'RECEIVE_AUTOMATE_MAILING_REPORTS';

// todo was in postcss branch?
// export const REQUEST_REPORTS = 'REQUEST_APPELLATE_SEARCH';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/reportsTabActionTypes.js